import { Dayjs } from 'dayjs';
import { Buffer } from "buffer";
//
import { badWords } from './badWords';
import config from 'config';
import i18n from 'i18n';

export const buildUserName = (user:any) => {
  if (!user) return '';
  return user.username ? user.username : `${user.name} ${user.surname}`;
};

export const getTimeRemaining = (start:Dayjs, end:Dayjs) => {
  const diff = end.diff(start);
  const seconds = Math.floor((diff/1000) % 60);
  const minutes = Math.floor((diff/1000/60) % 60);
  const hours = Math.floor((diff/(1000*60*60)) % 24);
  const days = Math.floor(diff/(1000*60*60*24));
  return { days, hours, minutes, seconds };
};

export const decodeBase64 = (hash:string) => {
  const hasToString = Buffer.from(hash, 'base64').toString();
  return JSON.parse(hasToString);
}

export const getSearchParam = (search:string, field:string):string|null => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(field) || null;
}

export const isNumeric = (value:string):boolean => {
  return /^\d+$/.test(value);
}

export const isProfanity = (value:string):boolean => {
  if (!value) return false;

  for (const word of badWords) {
    if (value.trim().toLowerCase().includes(word)) {
      return true;
    }
  }

  return false;
}

export const fetchWithAutoRetry = async (fetcher:Function, data:any = null) => {
  return await new Promise((resolve, reject) => {
    let retries = 0;
    const caller = () => {
      fetcher(data)
        .then((data:any) => {
          resolve(data)
        })
        .catch((error:any) => {
          if (error.status !== 502) reject(error);
          if (retries < config.autoRetryFetch.count) {
            retries++;
            setTimeout(() => {
              caller();
            }, config.autoRetryFetch.timeout);
          } else {
            reject(error);
          }
        });
    }
    retries = 1;
    caller();
  })
}

export const getEndOfPlace = (place: number) => {
  const lng = i18n.language;
  if (lng === 'en') return 'th';
  if (lng === 'se') return ':e';
  if (lng === 'es') {
    if ([4, 5, 6].includes(place)) return 'to';
    if ([7, 10].includes(place)) return 'mo';
    if (place === 8) return 'vo';
    if (place === 9) return 'no';
  }
}
